import { initializePushNotifications } from '@/api/push';
// Ordem obrigatória: base comum do Design System e, logo depois, o tema deste app. Nenhum
// componente `Dt*` carrega medida ou cor própria — sem o tema, eles ficam sem estilo.
import '@/design-system/tokens/index.css';
import '@/design-system/tokens/theme-tecnico.css';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { router } from './router';
import './global.css';
import { initializeAppInstall } from '@/design-system';

initializeAppInstall({ storageKey: 'dt-tec-pwa' });

// Tema padrão: o claro vem do atributo `data-theme="light"` do <html> no index.html (paridade
// com o protótipo, que declara data-theme="light" no html). Aqui só se sobrescreve quando há
// preferência salva (light ou dark); sem preferência, o padrão claro do index.html permanece.
// localStorage pode lançar no Safari antigo em modo privado; sem ele, vale o padrão claro do
// index.html (data-theme="light") — o toggle de tema só persiste quando o storage está disponível.
let savedTheme: string | null = null;
try {
  savedTheme = localStorage.getItem('dt_theme');
} catch {
  savedTheme = null;
}
if (savedTheme === 'light' || savedTheme === 'dark') document.documentElement.dataset['theme'] = savedTheme;

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.mount('#app');

// Limpeza direcionada: preserva workers de push e outros registros da origem.
if ('serviceWorker' in navigator) {
  void navigator.serviceWorker.getRegistrations().then(async (registrations) => {
    for (const registration of registrations) {
      const worker = registration.active ?? registration.waiting ?? registration.installing;
      if (worker !== null && /\/(?:flutter_service_worker|sw-cleanup)\.js$/u.test(new URL(worker.scriptURL).pathname)) {
        await registration.unregister();
      }
    }
    for (const key of await caches.keys()) {
      if (key.startsWith('flutter-')) await caches.delete(key);
    }
  }).catch(() => { /* Limpeza legada não impede o acesso ao portal. */ });
}
initializePushNotifications();
